
import TaskList from '../components/task-list.vue';

export default {
  name: 'ReadonlyTaskList',

  components: {
    TaskList: TaskList
  }
};